import type { Distance } from "../units/Units"
import type { Rectangle } from "./Rectangle"
import type { SpatialRectangle } from "./SpatialRectangle"

export type Media<T = Distance> = {
  readonly media_box: SpatialRectangle<T>
  readonly size: Rectangle<T>
  readonly trim_box: SpatialRectangle<T>
}
